import { PlanType } from '@showbie-socrative/socrative-utils';

import { useTeams } from '~teacher/hook/team';

export function useTeamSubscriptionPlan(selectedTeamId: string) {
  return useTeams({
    select: (data) => {
      const team = data.find(({ id }) => `${id}` === `${selectedTeamId}`);
      return team?.subscription?.plan ?? PlanType.Free;
    },
  });
}
